import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

export const wrapper = style({
  fontFamily: themeVars.font.Roboto,
  margin: '0 auto',
  zIndex: 2,
  width: '100%',
  backgroundColor: 'transparent',
});

export const content = style({
  borderRadius: '0.625rem',
  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  lineHeight: '1.5rem',
  marginBottom: '0.9375rem',
  fontSize: '1rem',
  padding: '1.25rem',
  color: '#333',
  wordWrap: 'break-word',
  '@media': {
    'screen and (max-width: 50em)': {
      margin: '33% auto 0',
    },
  },
});

export const contentText = style({
  marginTop: '3.125rem',
  fontSize: '1.25rem',
});

export const contentTitle = style({
  color: '#007a64',
  fontWeight: 'bold',
  fontSize: '1.375rem',
  '@media': {
    'screen and (max-width: 32.5em)': {
      width: '100%',
      display: 'flex',
    },
  },
});

export const comma = style({
  '@media': {
    'screen and (max-width: 32.5em)': {
      display: 'none',
    },
  },
});

export const imageWrapper = style({
  margin: '0 auto',
  width: 'fit-content',
});

export const image = style({
  width: 300,
  imageRendering: 'auto',
});

export const subText = style({
  fontFamily: themeVars.font.Roboto,
  fontSize: '0.875rem',
  margin: '0 auto',
  width: 'fit-content',
});
